import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IRecentContent } from '../models/recentContent';

interface RecentContentState {
  isLoading: boolean;
  content: IRecentContent[] | null;
  setIsLoading: (loading: boolean) => void;
  setContent: (content: IRecentContent[] | null) => void;
  resetRecentContent: () => void;
}

export const useRecentContentStore = create<RecentContentState>()(
  persist(
    (set) => ({
      isLoading: false,
      content: null,
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setContent: (content: IRecentContent[] | null) => set({ content: content }),
      resetRecentContent: () => set({ content: null, isLoading: false })
    }),
    {
      name: 'recent-content-store',
    },
  ),
);
